const NAVIGATION = [
  {
    name: "Poznaj nas",
    href: "/poznaj-nas/",
  },
  {
    name: "Oferta",
    href: "/oferta/",
  },
    {
    name: "Cennik",
    href: "https://booksy.com/pl-pl/22337_dream-factory-waxing-beauty-studio_depilacja_8820_krakow",
    external: true
  },
  {
    name: "Dlaczego my?",
    href: "/dlaczego-my/",
  },
  {
    name: "Galeria",
    href: "/galeria/",
  },
  {
    name: "Opinie",
    href: "/opinie/",
  },
  {
    name: "Blog",
    href: "/blog/",
  },
  {
    name: "Kontakt",
    href: "/kontakt/",
  },
];

export default NAVIGATION;
